
import Vue from 'vue';
import Component from 'vue-class-component';
import { PrescriptionAction, PrescriptionState } from '@/store/Prescription/PrescriptionRoot';

// Interfaces
import MainPackData from '@/ship/Models/MainPackData';

// Components
import { VAppLayout, VAppMain, VAppHeader } from '@/components/VApp';
import VHeader from '@/components/VHeader.vue';
import VHeaderPrescriptionMenu from '@/components/VHeaderPrescriptionMenu.vue';
import VImagePopup from '@/components/VImagePopup/VImagePopup.vue';

// Modals
import VChooseTask from '@/components/VModal/VChooseTask.vue';

@Component({
    components: { VAppLayout, VAppMain, VAppHeader, VHeader, VHeaderPrescriptionMenu, VChooseTask, VImagePopup },
})
export default class PrescriptionPage extends Vue {
    @PrescriptionAction GET_MAIN_PACK_DATA!: () => Promise<MainPackData>;
    @PrescriptionState mainPackData!: MainPackData;

    async created() {
        if (this.$route.meta!.authName) {
            await this.GET_MAIN_PACK_DATA();
        }
    }
}
